
interface LoginWrapperOptions {
    icon?: any,
    title?: any,
    description?: any,
}

function AuthBanner(props: LoginWrapperOptions) {

    

    return (
        <div className="auth_banner">
            <div className="icon">
                {props.icon}
            </div>
            <div className="title">
                {props.title}
            </div>
            <div className="description">
                {props.description}
            </div>
        </div>
    )
}

export default AuthBanner;
